import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/herz_us.jpg"

const Echokardiographie = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Echokardiographie - Herzultraschall </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                    Der Herzultraschall - oder auch Echokardiographie genannt,ist eine nicht-invasive, unblutige Untersuchungsmöglichkeit des Herzens und der herznahen Gefäße. Mit dem Ultraschall kann man mittels mechanischer Wellen Größe und Funktion des Herzens umfassend und zuverlässig analysieren. Im Gegensatz zur Röntgenuntersuchung kommt es beim Ultraschall zu keiner Strahlenbelastung des Patienten.
                    <br /> <br />
                    In der Kardiologie kommt der Herzultraschall vor allem zur Abklärung von Herzgeräuschen zum Einsatz, aber auch um Verlaufskontrollen bei arterieller Hypertonie, nach Myokardinfarkt, bei angeborenen Herzfehlern, nach Chemotherapien, etc. durchzuführen.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Echokardiographie;